<template>
  <chat-view />
</template>

<script>
import ChatView from "@/client/views/Chat.vue";

export default {
  name: "Chats",
  components: { ChatView },
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.chats.pageTitle",
      subTitle: "justopp.chats.pageSubtitle",
      backButton: true,
    },
  },
};
</script>

<style></style>
